// "How to Use Resi" module for the Training page: content from howToUseResiContent.js, with a quiz step
// at the end of each section (must pass to move on; progress saves like every other module).
import { HOW_TO_USE_RESI, quizStepId } from './howToUseResiContent';
import { makeSectionQuiz } from '../components/training/SectionQuiz';
import { SECTION_QUIZ_PASS } from './howToUseResiQuiz';

export const howToUseResiModule = {
  id: HOW_TO_USE_RESI.id,
  title: HOW_TO_USE_RESI.title,
  intro: HOW_TO_USE_RESI.intro,
  sections: HOW_TO_USE_RESI.sections.map((s) => ({
    id: s.id,
    title: s.title,
    steps: [...s.steps, {
      id: quizStepId(s.id), title: `${s.title} Quiz`, requireQuiz: true,
      body: [`Answer these to finish this section. You need ${SECTION_QUIZ_PASS}% to pass, and you can retake it as many times as you like.`],
      Component: makeSectionQuiz(HOW_TO_USE_RESI.id, quizStepId(s.id), s.quiz),
    }],
  })),
};
